import { apiRequest } from "./api";

/**
 * Fetch the paginated and filtered list of admin management users.
 *
 * @param {Object}      [params]
 * @param {number}      [params.page=1]        - Page number (min 1)
 * @param {number}      [params.limit=20]      - Items per page (1-100)
 * @param {string|null} [params.role]          - "admin" | "reviewer" | "agent" | null = all
 * @returns {Promise<Object>} The API envelope payload with data.items, data.total, data.page, etc.
 */
export async function fetchAdminUsers({
  page = 1,
  limit = 20,
  role = null,
} = {}) {
  const qs = new URLSearchParams();
  qs.set("page", page);
  qs.set("limit", limit);
  if (role) {
    qs.set("role", role);
  }

  const result = await apiRequest(`/admin/users?${qs.toString()}`);
  return result.data;
}

/**
 * Toggle the active/suspended status of a user.
 * Endpoint: POST /admin/users/{user_id}/toggle-status
 *
 * @param {string} userId - The user ID to toggle
 * @returns {Promise<Object>} Response data { user_id, status }
 */
export async function toggleUserStatus(userId) {
  const result = await apiRequest(`/admin/users/${userId}/toggle-status`, {
    method: "POST",
  });
  return result.data;
}

/**
 * Update details of a user.
 * Endpoint: PUT /admin/users/{user_id}/details
 *
 * @param {string} userId - The user ID to update
 * @param {Object} payload - { name, phoneNumber }
 * @returns {Promise<Object>} Response data
 */
export async function updateUserDetails(userId, { name, phoneNumber }) {
  const result = await apiRequest(`/admin/users/${userId}/details`, {
    method: "PUT",
    body: JSON.stringify({ name, phoneNumber }),
  });
  return result.data;
}

/**
 * Fetch the paginated and filtered list of consumer users (Zytama users).
 * Endpoint: GET http://localhost:8000/api/v2/admin/consumers-users
 *
 * @param {Object}      [params]
 * @param {number}      [params.page=1]        - Page number (min 1)
 * @param {number}      [params.limit=10]      - Items per page
 * @param {string}      [params.q=""]          - Search query
 * @param {string}      [params.status=""]     - "active" | "inactive" | ""
 * @returns {Promise<Object>} The API payload data containing users and pagination
 */
export async function fetchConsumersUsers({
  page = 1,
  limit = 10,
  q = "",
  status = "",
} = {}) {
  const qs = new URLSearchParams();
  qs.set("page", page);
  qs.set("limit", limit);
  if (q) {
    qs.set("q", q);
  }
  if (status) {
    qs.set("status", status);
  }

  const url = `https://distinguished-robby-aagati-15819a4f.koyeb.app/api/v1/admin/consumers-users?${qs.toString()}`;
  const result = await apiRequest(url);
  return result.data;
}

/**
 * Fetch a single consumer user's detail by ID.
 * Endpoint: GET http://localhost:8000/api/v1/admin/consumers-users/{userId}
 *
 * @param {string} userId
 * @returns {Promise<Object>} The API payload data containing user detail
 */
export async function fetchConsumerUserDetail(userId) {
  const url = `https://distinguished-robby-aagati-15819a4f.koyeb.app/api/v1/admin/consumers-users/${userId}`;
  const result = await apiRequest(url);
  return result.data;
}



